import {EventManager} from '@gongxigames/framework/core/fragments/EventManager';

export class DataStorage<P = {}> {
    protected _props: Record<any, any> = {};
    protected _eventManager: EventManager = new EventManager();

    protected copyValue(value: any): any {
        let newValue = value;

        if (value instanceof Array) {
            newValue = [...value];
        } else if (value instanceof Object && !(value instanceof String)) {
            newValue = {...value};
        }

        return newValue;
    }

    constructor(defaultProps: Partial<P>) {
        this._props = {};

        for (const key in defaultProps) {
            if (defaultProps.hasOwnProperty(key)) {
                this._props[key] = defaultProps[key];
            }
        }
    }

    public get<K extends keyof P>(key: K): P[K] {
        const value = this._props[key];

        return this.copyValue(value);
    }

    public off(key: keyof P | 'onChange', owner: Object): void {
        this._eventManager.off(key as string, owner);
    }

    public on<K extends keyof P>(key: K, callback: (newValue: P[K], oldValue: P[K]) => void, owner: Object): void {
        this._eventManager.on(key as string, callback, owner);
    }

    public onChange<K extends keyof P>(callback: (key: K, newValue: P[K], oldValue: P[K]) => void, owner: Object): void {
        this._eventManager.on('onChange', callback, owner);
    }

    public set<K extends keyof P>(key: K, value: P[K]): void {
        const oldValue = this.get(key);
        const newValue = this.copyValue(value);

        this._props[key] = newValue;

        this._eventManager.emit(key as string, newValue, oldValue);
        this._eventManager.emit('onChange', key, newValue, oldValue);
    }

    public get data(): P {
        const data: Record<any, any> = {};

        Object.keys(this._props).forEach(key => {
            data[key] = this.copyValue(this._props[key]);
        });

        return data as P;
    }
}
